
import moment from 'moment'

export function getActivityByWorkspaceSlug (state, slug) {
  return state.activity[slug]
}

export function getActivityDataByWorkspaceSlug (state, slug) {
  const activity = getActivityByWorkspaceSlug(state, slug) || {}
  return activity.data
}

export function getActivityRequestByWorkspaceSlug (state, slug) {
  const activity = getActivityByWorkspaceSlug(state, slug) || {}
  return {
    isRequesting: activity.isRequesting,
    didRequestFail: activity.didRequestFail
  }
}

export function getActivityCountByWorkspaceSlug (state, slug) {
  const activity = getActivityDataByWorkspaceSlug(state, slug) || []
  return activity.length
}

/**
 * All activity, filtered by `search` and `filter`.
 */

export function getMatchingActivity (state, slug) {
  const search = state.application.workspaceActivity.search.toLowerCase()
  const filter = state.application.workspaceActivity.filter.toLowerCase()
  const activities = getActivityDataByWorkspaceSlug(state, slug) || []
  return activities.filter(item => {
    const event = item.event.toLowerCase()
    if (!event.match(filter)) return false
    return matchesSearch(item, search)
  })
}

/**
 * Check if the given `item` matches the `search` filter.
 */

function matchesSearch (item, search) {
  const event = item.event.toLowerCase()
  if (event.match(search)) {
    return true
  }

  const type = item.type.toLowerCase()
  if (type.match(search)) {
    return true
  }

  const { properties } = item
  for (const property in properties) {
    if (!properties.hasOwnProperty(property)) continue
    const value = properties[property].toLowerCase()
    if (value.match(search)) return true
  }

  const date = moment(item.createdAt).format('MM/DD/YY hh:mm A')
  if (date.match(search)) {
    return true
  }

  return false
}



// WEBPACK FOOTER //
// ./selectors/activity.js